import { Combobox } from '@mantine/core';

import { mantineColors } from '@/theme/mantineColors';

export const ComboboxResolver = Combobox.extend({
  defaultProps: {
    zIndex: 900,
    withinPortal: true,
  },

  styles: () => ({
    dropdown: {
      boxSizing: 'border-box',
      padding: 0,
    },
    search: { boxSizing: 'border-box', border: 'none', borderBottom: `1px solid ${mantineColors.gray[4]}` },
    option: {
      borderRadius: 0,
      boxSizing: 'border-box',
    },
  }),
});
